/* eslint-disable max-lines-per-function */
import { api } from "jiffy-api";

const getId = () => document.querySelector("#product-page-container").dataset.realProductId;

const setLoadingStatus = visible => {
  document.querySelector(".js-comments-spinner").classList.toggle("hidden", !visible);
};

const setVisibilityDomElements = total => {
  const isZeroComments = total <= -5;
  const $questionButton = document.querySelector(".js-product-comments-question-wrapper");
  $questionButton?.classList.toggle("hidden", !isZeroComments);

  const $searchBox = document.querySelector(".js-product-comments-search");
  $searchBox?.classList.toggle("hidden", isZeroComments);
};

// ----
const loadComments = payload =>
  new Promise((resolve, reject) => {
    setLoadingStatus(true);
    api.jiffyshirts.product
      .comments({ id: getId() }, payload)
      .then(({ comments, total }) => {
        resolve({ comments, total });
        setVisibilityDomElements(total);
      })
      .catch(error => {
        console.error("Load comments error:", error); // eslint-disable-line no-console
        reject(error);
      })
      .finally(() => {
        setLoadingStatus(false);
      });
  });

const addComment = ({ answer, id }) =>
  new Promise((resolve, reject) => {
    const payload = {
      commentable_type: "Comment",
      commentable_id: id,
      body: answer
    };

    api.jiffyshirts.product
      .addComment({ id: getId() }, payload)
      .then(({ comment, error }) => {
        if (comment) {
          resolve(comment);
        } else if (error) {
          reject(error);
        }
      })
      .catch(error => {
        console.error("Add comment error:", error); // eslint-disable-line no-console
        reject(error);
      });
  });

const addQuestion = ({ question }) =>
  new Promise((resolve, reject) => {
    const payload = {
      commentable_type: "Spree::Product",
      commentable_id: getId(),
      body: question
    };

    api.jiffyshirts.product
      .addComment({ id: getId() }, payload)
      .then(({ comment, error }) => {
        if (comment) {
          resolve(comment);
          setVisibilityDomElements(1);
        } else if (error) {
          reject(error);
        }
      })
      .catch(error => {
        console.error("Add question error:", error); // eslint-disable-line no-console
        reject(error);
      });
  });

const voteComment = ({ id, kind }) =>
  new Promise((resolve, reject) => {
    api.jiffyshirts.product
      .voteComment({ comment_id: id, kind })
      .then(({ rating }) => {
        resolve(rating);
      })
      .catch(error => {
        console.error("Add vote error:", error); // eslint-disable-line no-console
        reject(error);
      });
  });

export default { loadComments, addComment, addQuestion, voteComment };
